export const data = {
  orderConfirm: {
    en:{},
    cn:{},
  },
  address: {
    en: {
      '收货地址': 'Shipping Address',
      '新建收货地址': 'Add new shipping address',
      '删除': 'Delete',
      '设为默认': 'Set as default',
      '默认': 'Default',
      '确认': 'Confirm',
      '取消': 'Cancel',
      '收货人': 'Consignee',
      '手机号': 'Phone Number',
      '所在地区': 'Region',
      '详细地址': 'Detailed \r\n Address',
      '邮政编码': 'Post Code',
      '地址标签': 'Address Tag',
      '家': 'Home',
      '公司': 'Co.',
      '学校': 'Sch',
      '设置为默认收货地址': 'Set as default shipping address',
      'addressTips': 'Reminder: this address is recommended by default for each order',
      'notice': 'Warm Tip: The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '温馨提示': 'Reminder',
      '保存地址': 'Save Address',
      '已经到底了': 'No more updates',
      '详细地址提示': 'Street, house number, community, building number and room number, etc.',
      '请选择': 'Please select',
      '请输入11位手机号': 'Please enter 11-digit phone number',
      '验证码': 'Identifying code',
      '请输入验证码': 'Pls input identifying code',
      '获取验证码': 'Obtain identifying code',
      '重新发送': 'Send again',
      '输入短信验证码': 'Please enter SMS verification code',
      '待完善': 'To be completed',
      '下一步': 'next',
      '新的支付密码': 'New payment password',
      '确认新的支付密码': 'Confirm new payment password',
      '输入4位数字密码': 'Enter 4 numerical digits password',
      '再次输入4位数字密码': 'Enter 4 numerical digits password again',
      '确认设置': 'Confirm setup',
      '请输入手机号码': 'Pls input phone number ',
      'checkCode': 'Check code has been sent to your phone, pls check',
      'freightPay': 'The expense of pay product shall be independently given to deliveryman, which is not included in total price ',
      '更多地址': 'More address',
      '新建地址': 'Add New Address',
      '编辑地址': 'Edit address',
      '请填写收货人姓名': 'Please fill in the consignee name',
      '请填写收货人手机号码': 'Please fill in the consignee mobile number',
      '配送至': 'Delivery Address',
      '收货地址删除成功': 'Successful',
      '收货地址删除失败': 'Failed',
      '最多只能输入5个字': 'Only input five words',
      '确定': 'Confirm',
      '确认': 'Confirm',
      '编辑': 'Edit',
      '确认删除该地址吗': 'Are you sure to delete this address?',
      '再想想': 'Think twice',
      '修改的信息还未保存': 'You haven’t saved the alteration.',
      '确认现在返回么': 'Are you sure to return now?',
      '暂无收货地址': "No delivery address",
      '您还没有收货地址哦': "You don't have delivery address",
      '快去新建吧': 'Establish now ！~',
    },
    cn: {
      '默认': '默认',
      '收货地址': '收货地址',
      '新建收货地址': '新建收货地址',
      '删除': '删除',
      '设为默认': '设为默认',
      '确认': '确认',
      '取消': '取消',
      '收货人': '收货人',
      '手机号': '手机号',
      '所在地区': '所在地区',
      '详细地址': '详细地址',
      '邮政编码': '邮政编码',
      '地址标签': '地址标签',
      '家': '家',
      '公司': '公司',
      '学校': '学校',
      '设置为默认收货地址': '设置为默认收货地址',
      'addressTips': '提醒：每次下单会默认推荐使用该地址',
      '温馨提示': '温馨提示',
      'notice': '温馨提示：2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，务必实名填写。请您实名填写收件信息，否则将不予发货，谢谢配合！',
      '保存地址': '保存地址',
      '已经到底了': '已经到底了',
      '详细地址提示': '街道、门牌号、小区、楼栋号、单元室等',
      '请选择': '请选择',
      '请输入11位手机号': '请输入11位手机号',
      '验证码': '验证码',
      '请输入验证码': '请输入验证码',
      '获取验证码': '获取验证码',
      '重新发送': '重新发送',
      '输入短信验证码': '输入短信验证码',
      '待完善': '待完善',
      '下一步': '下一步',
      '新的支付密码': '新的支付密码',
      '确认新的支付密码': '确认新的支付密码',
      '输入4位数字密码': '输入4位数字密码',
      '再次输入4位数字密码': '再次输入4位数字密码',
      '确认设置': '确认设置',
      '请输入手机号码': '请输入手机号码',
      'checkCode': '校验码已发送至您的手机，请查收',
      '输入的密码4位数字不能相同或连续': '输入的密码4位数字不能相同或连续',
      '请再次输入四位数字支付密码': '请再次输入四位数字支付密码',
      'freightPay': '付费产品的费用需单独支付给配送员，此处不计入总价',
      '更多地址': '更多地址',
      '新建地址': '新建地址',
      '编辑地址': '编辑地址',
      '请填写收货人姓名': '请填写收货人姓名',
      '请填写收货人手机号码': '请填写收货人手机号码',
      '配送至': '配送至',
      '收货地址删除成功': '收货地址删除成功',
      '收货地址删除失败': '收货地址删除失败',
      '最多只能输入5个字': '最多只能输入5个字',
      '确定': '确定',
      '确认': '确认',
      '编辑': '编辑',
      '确认删除该地址吗': '确认删除该地址吗？',
      '再想想': '再想想',
      '修改的信息还未保存': '修改的信息还未保存,',
      '确认现在返回么': '确认现在返回么？',
      '您还没有收货地址哦': '您还没有收货地址哦',
      '暂无收货地址': '暂无收货地址',
      '快去新建吧': '快去新建吧！~',
    },
  },
  card: {
    en: {
      '请输入短信验证码': 'Please enter SMS verification code',
      '请设置4位支付密码': 'Please Set 4-digit payment password',
      '请确认支付密码': 'please confirm payment password',
      '请输入支付密码': 'Please enter payment password',
      'setPwdTips': 'No payment password set, please select settings',
      '重新输入': 'Re-enter',
      '发送验证码': 'Send Verification Code',
      '验证码已发送至': 'Verification code has been sent to',
      '绑定福利卡': 'Bind benefit card',
      'cardPWD': 'Please enter 16-digit card password, not case sensitive',
      'cardPWD1': 'Please enter 16-digit card password',
      'cardPWD2': 'not case sensitive',
      '立即绑定': 'Bind now',
      '扫码绑定': 'Scan to bind',
      '可用次数': 'Available times',
      '可用余额': 'Available Balances',
      '次': 'Times',
      '卡号': 'Card No.',
      '有效期至': 'Expiration date',
      '确认绑定': 'Confirm bind',
      '确认绑定福利卡': 'Confirm binding benefit card',
      '请输入正确的卡密': 'Please enter correct card password',
      '绑定福利卡成功': 'Successful',
      '抵扣': 'Deduction',
      '请输入16位卡密码': 'Pls input card password of 16 digits',
      '确认绑定这张福利卡吗': 'Are you sure to bind this bonus card',
      '请输入四位数字支付密码': 'Pls input password of 4 digits',
      '输入的密码4位数字不能相同或连续': '4-digit password cannot be same or continuous',
      '请再次输入四位数字支付密码': 'Pls input password of 4 digits again',
      'checkPayPwd': 'Password is inconsistent, please retype it',
      '暂无可用余额': 'No balances available',
      '暂无可用积分': 'No points available temporarily',
      '福豆': 'FuDou',
      '无可用卡': 'No available card',
      'cardlock': 'Card locked, fail to bind',
      'cardexpire': 'Expired coupon, fail to bind',
      'cardbind': "Sorry, the card has been bound",
      '可用积分': "Available Points",
      '次卡': "Times Card",
      '点卡': "Points Card",
      '尾号': "tail no.",
      '次卡[尾号X]支付': 'Paid by times card [tail no. X]',
      '点卡[尾号X]支付': 'Paid by points card [tail no. X]',
      'X次': 'X times',
    },
    cn: {
      '请设置4位支付密码': '请设置4位支付密码',
      '请输入短信验证码': '请输入短信验证码',
      '重新输入': '重新输入',
      '请输入支付密码': '请输入支付密码',
      '请确认支付密码': '请确认支付密码',
      'setPwdTips': 'No payment password set, please select settings',
      '验证码已发送至': '验证码已发送至',
      '发送验证码': '发送验证码',
      '绑定福利卡': '绑定福利卡',
      'cardPWD': '请输入16位卡密，卡密不区分大小写',
      'cardPWD1': '请输入16位卡密',
      'cardPWD2': '卡密不区分大小写',
      '立即绑定': '立即绑定',
      '扫码绑定': '扫码绑定',
      '可用次数': '可用次数',
      '可用余额': '可用余额',
      '次': '次',
      '卡号': '卡号',
      '有效期至': '有效期至',
      '确认绑定': '确认绑定',
      '确认绑定福利卡': '确认绑定福利卡',
      '请输入正确的卡密': '请输入正确的卡密',
      '绑定福利卡成功': '绑定福利卡成功',
      '抵扣': '抵扣',
      '请输入16位卡密码': '请输入16位卡密码',
      '确认绑定这张福利卡吗': '确认绑定这张福利卡吗',
      '请输入四位数字支付密码': '请输入四位数字支付密码',
      'checkPayPwd': '两次输入不一致,请重新输入',
      '暂无可用余额': '暂无可用余额',
      '暂无可用积分': '暂无可用积分',
      '无可用卡': '无可用卡',
      '福豆': '福豆',
      'cardlock': '卡已锁定，无法绑定',
      'cardexpire': '卡券已过期，无法绑定',
      'cardbind': '抱歉，该卡已被绑定',
      '可用积分': "可用积分",
      '次卡': "次卡",
      '点卡': "点卡",
      '尾号': "尾号",
      '次卡[尾号X]支付': '次卡[尾号X]支付',
      '点卡[尾号X]支付': '点卡[尾号X]支付',
      'X次': 'X次',
    },
  },
  user: {
    en: {
      '知道了': 'Read',
      '通知': 'Notice',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
    },
    cn: {
      '知道了': '知道了',
      '通知': '通知',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
    },
  },
  my:{
    en: {
      "平台服务费": "Platform service fee",
      "复制成功":"Successful",
      "复制失败":"Failed",
      "复制":"Copy",
      "我的":"Me",
      '请填写身份证号':'Fill in ID card no.',
      '请填写取票人信息':'Pls fill in the information of person taking ticket',
      '身份证填写不合法请重填':'Illegally fill in ID card no., pls rewrite',
      '共X张': 'X in total',
      '不退不换':'No refund or change',
      '每笔订单限购6张哦':'6 tickets are limited',
      '距离开售还有':'before start',
      '本商品为预售商品正式开票后将第一时间通知你':'This is pre-sale product. You will be notified upon official opening immediately',
      '发送成功':'Successful',
      '请填写正确的手机号码':'Pls properly input phone no',
      '请填写正确的验证码':'Pls s properly fill in identifying code',
      '请填写验证码':'Pls fill in identifying code',
      '请填写手机号':'Pls fill in phone number',
      '请填写身份证':'Pls fill in ID Card No',
      '请填写取票人姓名':'Pls fill in the name of person taking ticket',
      '添加取票人':'Add person to take ticket',
      '确认订单':'Confirm order',
      '填写城市或者首字母':'Input city or initial',
      '热':'Hot',
      '自定义':'Customized',
      '已选':'Selected',
      '最高价':'Max price',
      '最低价':'Min price',
      '继续填写':'Continue to fill in',
      '确认退出':'Confirm',
      '退出当前界面，之前已经填写的内容将不会保存哦':'What you previously filled in will not be saved if you exit from current interface.',
      '继续添加':'Continue to add',
      '手机号':'Phone number',
      '全部':'All',
      '起':'Starting',
      '演出精选':'Selected performance',
      '下单后可在我的订单中查看取票点':'View ticket address in [my order] after placing an order',
      '下单后可在我的订单中查看取票地址':'View ticket address in [my order] after placing an order',
      '电话':'Cellphone: ',
      '时间':'time: ',
      '地址':'Address: ',
      '快去新建吧':"Create now!",
      '您还没有收货地址哦':'You don’t have delivery address ',
      '修改的信息还未保存,确认现在返回么':"You haven’t saved the alteration. Are you sure to return now?",
      '邮管局通知所有快递物流信息上收件人':'The Postal Administration informs that since September 01, 2018, the name of the recipient as well as the name of the sender on the logistics information of all express deliveries must be filled in with the real name, and it is prohibited to fill in with surnames and other characters. Please fill in the recipient information in your real name, otherwise no delivery will be made. Thank you for your cooperation!',
      '手机号码':'Phone number',
      '收货人':'Consignee',
      '保存':'Save',
      '身份证用于演出入场或下单，请核实后填写':'ID card is for entrance or order, pls fill in it after verification',
      '取票人':'Person taking ticket',
      '价格详情':'Price Details',
      '票品详情':'Ticket details',
      '支付明细':'Payment details',
      '运费':'Freight',
      '优惠':'Discount',
      '票品总价':'Ticket Total price',
      '取票点':'Ticket taking',
      '取票地址':'Ticket Address',
      '取票二维码': 'Ticket QR code',
      '取票码': 'Ticket collection code',
      '请添加取票人':'Pls add the person taking ticket',
      '请选择收货地址':'Pls select delivery address',
      '身份证电子票':'ID card e-ticket',
      '短信码电子票':'SMS e-ticket',
      '电子票':'E-ticket',
      '自助机取票':'Self-service ticketing',
      '上门自取':'Home delivery',
      '快递配送':'Delivery',
      '取票方式':'Way to take ticket',
      '提交订单':'Submit order',
      '明细':'details',
      '含运费':'Freight included',
      '需支付':'To be paid',
      '座位':'seats',
      '票档':'Ticket level',
      '身份证':'ID Card',
      '姓名':'Name',
      '无座':'No seat',
      '票品一经售出 不支持退换':'Ticket cant be modified or exchanged once it is sold',
      '观演人':'Audience',
      '确认提交':'Confirm',
      '修改':'Modify',
      '不支持退换':'Not available for return',
      '票品一经售出':'Once ticket is sold',
      '请核实您输入的取票人信息':'Pls verify information of person taking ticket',
      '请核实您输入的取票人及观演人信息':'Pls verify information of person taking ticket and audience',
      '为了不影响您的观演':'To safeguard your viewing',
      '信息核实':'Ticket details',
      '周末场':'Weekend session',
      '一月内':'Within one month',
      '本周内':'Within this week',
      '最近开场':'Latest session',
      '低价优先':'Low price first',
      '综合排序':'Comprehensive ranking',
      '查看所有演出':'View all shows',
      '抱歉没有找到相关的演出哦':'Sorry, no relevant shows found',
      '切换其它城市':'Change city',
      '当前城市暂未开放':'This city is unavailable',
      '分':'Credit',
      '立即购票':'Buy now',
      '客服': 'Service',
      '演出列表':'Show list',
      '图书':'Books',
      '保险':'Insurance',
      '企业活动':'Business activity',
      '健康生活':'Healthy life',
      '演出话剧':'Drama',
      '旅游玩乐':'Tourism',
      '生日汇':'Birthday party',
      '电影':'Movie',
      '节日礼包':'Festival gift bag',
      '东福超市':'supermarket',
      '优选生活':'Preferred life',
      '个人中心':'Me',
      '福利商城':'Mall',
      '商城首页':'Mall',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '无数据': 'No data',
      '收起': 'Fold',
      '展开': 'Unfold',
      '该场次票档已售罄哦': 'Sold out',
      '缺票登记成功': 'Successful ticket registration',
      '已经收到您的缺票登记': 'Your ticket missing registration has been received',
      '返回首页': 'Back homepage',
      '无手机号': 'No phone number',
      '请添加观演人': 'Please add information about the viewer',
      '编辑取票人': 'Edit ticket taker',
      '请添加完对应票档的观演人信息': 'Please add the audience information of the corresponding ticket file',
      '无演出信息': 'No performance information',
      '请添加X位观演人': 'Please add X players',
      '只能添加X位观演人': 'Only X players can be added',
      '只能添加X位取票人': 'Only X ticket taker can be added',
      '请选择所在地区': 'Please select your region',
      '收货地址新建成功': 'The receiving address was newly created',
      '请填写详细地址':'Please fill in the detailed address',
      '收货地址编辑成功':'Receiving address edited successfully',
      '返回福利商城': 'Return to Welfare Mall',
      '重新获取': 'Reacquire',
      '请先选择场次以及票档': 'Please Select the Session and Ticket File First'


    },
    cn: {
      "平台服务费": "平台服务费",
      '请填写身份证号':'请填写身份证号',
      '请填写取票人信息':'请填写取票人信息',
      '身份证填写不合法请重填':'身份证填写不合法，请重填',
      '不退不换':'不退不换',
      '每笔订单限购6张哦':'每笔订单限购6张哦',
      '距离开售还有':'距离开售还有',
      '本商品为预售商品正式开票后将第一时间通知你':'本商品为预售商品，正式开票后将第一时间通知你',
      '发送成功':'发送成功',
      '请填写正确的手机号码':'请填写正确的手机号码',
      '请填写正确的验证码':'请填写正确的验证码',
      '请填写验证码':'请填写验证码',
      '请填写手机号':'请填写手机号',
      '请填写身份证':'请填写身份证',
      '请填写取票人姓名':'请填写取票人姓名',
      '添加取票人':'添加取票人',
      '确认订单':'确认订单',
      '填写城市或者首字母':'填写城市或者首字母',
      '热':'热',
      '自定义':'自定义',
      '已选':'已选',
      '最高价':'最高价',
      '最低价':'最低价',
      '继续填写':'继续填写',
      '确认退出':'确认退出',
      '退出当前界面，之前已经填写的内容将不会保存哦':'退出当前界面，之前已经填写的内容将不会保存哦~',
      '继续添加':'继续添加',
      '手机号':'手机号',
      '全部':'全部',
      '起':'起',
      '演出精选':'演出精选',
      '下单后可在我的订单中查看取票点':'下单后可在【我的订单】中查看取票点',
      '下单后可在我的订单中查看取票地址':'下单后可在【我的订单】中查看取票地址',
      '电话':'电话：',
      '时间':'时间：',
      '地址':'地址：',
      '快去新建吧':"快去新建吧！",
      '您还没有收货地址哦':'您还没有收货地址哦~',
      '修改的信息还未保存,确认现在返回么':"修改的信息还未保存,确认现在返回么？",
      '邮管局通知所有快递物流信息上收件人':"2018.09.01起，邮管局通知：所有快递物流信息上收件人以及寄件人信息禁止出现X先生/X小姐等字样，请您实名输入收件信息，否则将不予发货，谢谢配合！",
      '手机号码':'手机号码',
      '收货人':'收 货 人',
      '保存':'保存',
      '身份证用于演出入场或下单，请核实后填写':'身份证用于演出入场或下单，请核实后填写',
      '取票人':'取票人',
      '价格详情':'价格详情',
      '票品详情':'票品详情',
      '支付明细':'支付明细',
      '运费':'运费',
      '优惠':'优惠',
      '票品总价':'票品总价',
      '取票点':'取票点',
      '取票地址':'取票地址',
      '取票二维码': '取票二维码',
      '取票码': '取票码',
      '请添加取票人':'请添加取票人',
      '请选择收货地址':'请选择收货地址',
      '身份证电子票':'身份证电子票',
      '短信码电子票':'短信码电子票',
      '电子票':'电子票',
      '自助机取票':'自助机取票',
      '上门自取':'上门自取',
      '快递配送':'快递配送',
      '取票方式':'取票方式',
      '提交订单':'提交订单',
      '明细':'明细',
      '含运费':'含运费',
      '需支付':'需支付',
      '座位':'座位',
      '票档':'票档',
      '身份证':'身份证',
      '姓名':'姓名',
      '无座':'无座',
      '票品一经售出 不支持退换':'票品一经售出 不支持退换',
      '观演人':'观演人',
      '确认提交':'确认提交',
      '修改':'修改',
      '不支持退换':'不支持退换',
      '票品一经售出':'票品一经售出',
      '请核实您输入的取票人信息':'请核实您输入的取票人信息',
      '请核实您输入的取票人及观演人信息':'请核实您输入的取票人及观演人信息',
      '为了不影响您的观演':'为了不影响您的观演',
      '信息核实':'信息核实',
      '周末场':'周末场',
      '一月内':'一月内',
      '本周内':'本周内',
      '最近开场':'最近开场',
      '低价优先':'低价优先',
      '综合排序':'综合排序',
      '查看所有演出':'查看所有演出',
      '抱歉没有找到相关的演出哦':'抱歉~没有找到相关的演出哦',
      '切换其它城市':'切换其它城市',
      '当前城市暂未开放':'当前城市暂未开放',
      '分':'分',
      '立即购票':'立即购票',
      '演出列表':'演出列表',
      '图书':'图书',
      '保险':'保险',
      '企业活动':'企业活动',
      '健康生活':'健康生活',
      '演出话剧':'演出话剧',
      '旅游玩乐':'旅游玩乐',
      '生日汇':'生日汇',
      '电影':'电影',
      '节日礼包':'节日礼包',
      '东福超市':'东福超市',
      '优选生活':'优选生活',
      '个人中心':'我的',
      '福利商城':'福利商城',
      '商城首页':'商城首页',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '共X张': '共X张',
      '无数据': '无数据',
      '收起': '收起',
      '展开': '展开',
      '该场次票档已售罄哦': '该场次票档已售罄哦',
      '缺票登记成功': '缺票登记成功',
      '已经收到您的缺票登记': '已经收到您的缺票登记',
      '返回首页': '返回首页',
      '无手机号': '无手机号',
      '请添加观演人': '请添加观演人',
      '编辑取票人': '编辑取票人',
      '请添加完对应票档的观演人信息': '请添加完对应票档的观演人信息',
      '无演出信息': '无演出信息',
      '请添加X位观演人': '请添加X位观演人',
      '只能添加X位观演人': '只能添加X位观演人',
      '只能添加X位取票人': '只能添加X位取票人',
      '请选择所在地区': '请选择所在地区',
      '收货地址新建成功': '收货地址新建成功',
      '请填写详细地址': '请填写详细地址',
      '收货地址编辑成功': '收货地址编辑成功',
      '返回福利商城': '返回福利商城',
      '重新获取': '重新获取',
      '请先选择场次以及票档': '请先选择场次以及票档',
    },
  },
  list: {
    en: {
      '热门':'Popular',
      '订单详情':'Order details',
      '张':'/piece',
      '立即获取':'Obtain',
      '该手机号将用于接收出票信息':'This phone No. will receive ticket info',
      '演出入场电子码':'Entrance e-code',
      '加载中': "Loading...",
      '没有更多了':'No more',
      '加载失败': "Fail to load. Pull up to reload",
      '筛选':'Screen',
      '重置':'Re-set',
      '票价':'Ticket rates',
      '禁止携带物品说明':'Notes on restricted items',
      '寄存说明':'Storage instructions',
      '演出销售结束时间':'End time',
      '演出开售时间':'Start time',
      '观影须知':'Viewing INS',
      // '观影须知':'notes',
      '自动取票':'Ticket',
      '电子票入场提示':'E-ticket entrance prompt',
      '入场说明':'Admission instructions',
      '退换政策':'Exchange policy',
      '儿童购票说明':'Child ticket instructions',
      '实名制购票':'Real-name ticketing',
      '是否支持选座':"Is it available for choosing a seat",
      '因福利卡券在购买时':'DF has issued invoice to your employer when coupons are sold, so DF is unable to issue invoice again if you use coupon to pay the bill. We are sorry for inconvenience.',
      '发票说明':'Invoice instructions',
      '购票说明':'Ticket INS',
      // '购票说明':'Ticketing ',
      '演出详情':'Show details',
      // '演出详情':'details',
      '当前定位城市':'Locate current city',
      '热门城市':'Popular City',
      '最近访问城市':'Latest visited city',
      '缺票':'Sell out',
      '售罄':"Sell out",
      '预售':'Presale',
      '一旦有票我们将第一时间用短信通知您':"We will immediately send SMS to you once ticket is available",
      '我知道了':"I got it",
      '大麦只显示人民币金额及货币单位':"Damai only displays RMB amount and monetary unit (¥)",
      '即将前往大麦选座页':'Go to Damai seat selection page',
      '缺票登记':'Stockout registration',
      '请前往选座页':"Pls go to seat selection page",
      '立即选座':'Pls select seat',
      '因合作商调整，票价可能显示为人民币':"Unit of ticket rate is RMB due to the change of cooperators",
      '确认购票':"Confirm ticket",
      '已优惠':'Discounted',
      '每笔订单限购6张':'6 tickets are limited',
      '请选择数量':'Pls select quantity',
      '套票包含':'Combined ticket includes',
      '份':'Portion',
      '场次':'Session',
      '重新支付':'Pay again',
      '查看订单':'View order',
      '订单支付遇到问题，请尝试重新支付':'Error occurred, pls try to pay again',
      '支付失败':'Payment failure',
      '查看详情':'View details',
      '您的订单我们已收到':'We have received your order and process it within 2-3 workdays. Pls ask for help if required:',
      '支付成功':'Successful',
      '提交':'Submit',
      '请先选择评分':'Pls score firstly',
      '请对本次兑换体验做出评价':'Pls commend this exchange',
      '感谢您的反馈':'Thanks for your feedback',
      '已提交':'Submitted',
      '赶紧去购物吧':'go shopping now!',
      '还没有您的订单哦':'You don’t have orders~',
      '您确认要取消该订单吗':'Are you sure you want to cancel this order?',
      '历史订单':'Order history',
      '演出订单':'Performance order',
      '姓名':'Name',
      '观演人信息':'Audience information',
      '退款明细':'Refund details',
      '分销渠道':'Distribution channel',
      '顺丰工会积分':'SF labor union credit',
      '中粮工会积分':'COFCO labor union credit',
      '银联':'Unionpay',
      '合计':'Total',
      '该演出为预售状态':'This performance is presold. Ticket info. will be immediately sent to you once it is issued. Pls wait patiently',
      '创建时间':'Creation time:',
      '订单号':'Order number:',
      '大麦订单号':'Damai order No:',
      '订单信息':'Order information',
      '付款时间': 'Payment time',
      '微信付款时间':'Wechat payment time:',
      "待支付":"To be paid",
      "已支付":"Paid",
      "已取消":"Cancelled",
      "已完成":"Completed",
      "出票中":"Issuing",
      "出票成功":"Successful",
      "申请退款":"Apply for a refund",
      "退款成功":"Successful",
      "退款失败":"Failed",
      '支付宝付款时间':'Alipay payment time:',
      '立即支付':'Pay now',
      '取消订单':'Cancel order',
      '确认取消':'Confirm cancellation',
      '暂不取消':'Undecided',
      '您确认要取消该订单吗':'Are you sure you want to cancel this order?',
      '取票人信息':'Information of person taking ticket',
      '取票信息':'Ticket info',
      '该票务由大麦网提供':'Ticket offered by Damai',
      '请凭身份证入场':'Admission by ID card',
      '出票成功后，可用取票码或二维码换取纸质票':'Use ticket code or QR code to exchange paper ticket once ticket is issued',
      '查看':'View',
      '出票成功后':'Home delivery is available once ticket is issued. Pls provide Damai order No., name of person taking ticket and phone No. to get ticket',
      '查看物流':'View logistics',
      '演出票未发货，您耐心等待':'Ticket is not delivered, pls wait patiently~',
      '已发货':'Delivered',
      '已签收':'Accepted',
      '签收时间':'Acceptance time:',
      '快递编号':'Express code:',
      '自动扣款': 'Auto deduction',
      '支付设置': 'Payment settings',
      '还剩': 'Left ',
      '天': ' day ',
      '时': ' hour ',
      '分': ' min ',
      '秒': ' sec ',
      '企业积分': 'Enterprise points'
    },
    cn: {
      '热门':'热门',
      '订单详情':'订单详情',
      '张':'/张',
      '立即获取':'立即获取',
      '该手机号将用于接收出票信息':'该手机号将用于接收出票信息',
      '演出入场电子码':'演出入场电子码',

      '加载中': "加载中...",
      '没有更多了': "没有更多了",
      '加载失败': "加载失败，上拉重新加载",
      '筛选':'筛选',
      '重置':'重置',
      '票价':'票价',
      '禁止携带物品说明':'禁止携带物品说明',
      '寄存说明':'寄存说明',
      '演出销售结束时间':'演出销售结束时间',
      '演出开售时间':'演出开售时间',
      '观影须知':'观影须知',
      '自动取票':'自动取票',
      '电子票入场提示':'电子票入场提示',
      '入场说明':'入场说明',
      '退换政策':'退换政策',
      '儿童购票说明':'儿童购票说明',
      '实名制购票':'实名制购票',
      '是否支持选座':"是否支持选座",
      '因福利卡券在购买时':'因福利卡券在购买时，我司已为您公司开具过发票，所以使用卡券全额支付的订单，我们无法再为您开具发票，由此给您带来的不便，敬请谅解。',
      '发票说明':'发票说明',
      '购票说明':'购票说明',
      '演出详情':'演出详情',
      '当前定位城市':'当前定位城市',
      '热门城市':'热门城市',
      '最近访问城市':"最近访问城市",
      '缺票':'缺票',
      '售罄':"售罄",
      '预售':'预售',
      '一旦有票我们将第一时间用短信通知您':"一旦有票，我们将第一时间用短信通知您",
      '我知道了':"我知道了",
      '大麦只显示人民币金额及货币单位':"大麦只显示人民币金额及货币单位(￥)",
      '即将前往大麦选座页':'即将前往大麦选座页',
      '缺票登记':'缺票登记',
      '请前往选座页':"请前往选座页",
      '立即选座':'立即选座',
      '因合作商调整，票价可能显示为人民币':'因合作商调整，票价可能显示为人民币',
      '确认购票':"确认购票",
      '已优惠':'已优惠',
      '每笔订单限购6张':'每笔订单限购6张',
      '请选择数量':'请选择数量',
      '套票包含':'套票、包含',
      '份':'份',
      '场次':'场次',
      '重新支付':'重新支付',
      '查看订单':'查看订单',
      '订单支付遇到问题，请尝试重新支付':'订单支付遇到问题，请尝试重新支付',
      '支付失败':'支付失败',
      '查看详情':'查看详情',
      '您的订单我们已收到':'您的订单我们已收到，将在2-3个工作日内处理完成。如有疑问请联系：',
      '支付成功':'支付成功',
      '提交':'提交',
      '请先选择评分':'请先选择评分',
      '请对本次兑换体验做出评价':'请对本次兑换体验做出评价',
      '感谢您的反馈':'感谢您的反馈',
      '已提交':'已提交',
      '赶紧去购物吧':'赶紧去购物吧！',
      '还没有您的订单哦':'还没有您的订单哦~',
      '您确认要取消该订单吗':'您确认要取消该订单吗?',
      '历史订单':'历史订单',
      '演出订单':'演出订单',
      '姓名':'姓名',
      '观演人信息':'观演人信息',
      '退款明细':'退款明细',
      '分销渠道':'分销渠道',
      '顺丰工会积分':'顺丰工会积分',
      '中粮工会积分':'中粮工会积分',
      '银联':'银联',
      '合计':'合计',
      '该演出为预售状态':'该演出为预售状态,演出开票后,将第一时间发送取票信息,请耐心等待',
      '创建时间':'创建时间：',
      '订单号':'订单号：',
      '大麦订单号':'大麦订单号：',
      '订单信息':'订单信息',
      '付款时间': '付款时间',
      '微信付款时间':'微信付款时间：',
      '支付宝付款时间':'支付宝付款时间：',
      '立即支付':'立即支付',
      '取消订单':'取消订单',
      '确认取消':'确认取消',
      '暂不取消':'暂不取消',
      '您确认要取消该订单吗':'您确认要取消该订单吗',
      '取票人信息':'取票人信息',
      '取票信息':'取票信息',
      '该票务由大麦网提供':'该票务由大麦网提供',
      '请凭身份证入场':'请凭身份证入场',
      '出票成功后，可用取票码或二维码换取纸质票':'出票成功后，可用取票码或二维码换取纸质票',
      '查看':'查看',
      '出票成功后':'出票成功后，可上门自取。取票时，请提供大麦订单号、取票人姓名、手机号',
      '查看物流':'查看物流',
      '演出票未发货，您耐心等待':'演出票未发货，您耐心等待~',
      '已发货':'已发货',
      '已签收':'已签收',
      '签收时间':'签收时间：',
      '快递编号':'快递编号：',
      '自动扣款': '自动扣款',
      '支付设置': '支付设置',
      '还剩': '还剩',
      '天': '天',
      '时': '时',
      '分': '分',
      '秒': '秒',
      '企业积分': '企业积分',
    },
  },
  order: {
    en: {
      '当前场次不可售': 'Not currently available for sale',
    },
    cn: {
      '当前场次不可售': '当前场次不可售',
    }
  }
};
